import styled from "styled-components";

interface Tooltip {
  background?: string
  fontsize?: string
  color?: string
}

export const StyledTooltip = styled.div<Tooltip>`
  position: relative;

  .tooltip-text {
    visibility: hidden;
    width: 230px;
    background-color: ${props => props.background};
    color: ${props => props.color};
    font-size: ${props => props.fontsize};
    text-align: center;
    border-radius: 2px;
  
    position: absolute;
    z-index: 1;

    bottom: 100%;
    left: 20%;
    margin-left: -108px;
    margin-bottom: .5rem;
  }

  &:hover .tooltip-text {
    visibility: visible;
  }

  &:hover span:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    width: 0; height: 0;
    border-top: 5px solid ${props => props.background};
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
  }
`